import { Container, Stack, Title } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { ReviewerChecklistSection } from "../features/reviewerChecklist/ReviewerChecklistSection";

// Страница «Настройки → Чек-лист готовности». Тонкий контейнер
// над секцией управления per-(org, repo) чек-листом reviewer'а — как
// `SettingsTrustRulesPage`.
export function ReviewerChecklistPage(): ReactElement {
  const { t } = useTranslation();
  return (
    <Container py="xl">
      <Stack gap="xl">
        <Title order={1}>{t("reviewerChecklist.pageTitle")}</Title>
        <ReviewerChecklistSection />
      </Stack>
    </Container>
  );
}
